import React from 'react';
import { PP_SUBNAV_ICONS } from '../../patients/config';
import type { PatientProfileTab } from '../../patients/types';
import { Icon } from '../Icon/Icon';

export interface PatientProfilePlaceholderProps {
  tab: PatientProfileTab;
}

export function PatientProfilePlaceholder({ tab }: PatientProfilePlaceholderProps) {
  return (
    <div className="pp-fade flex min-h-[320px] flex-col items-center justify-center rounded-[var(--r-xl)] border border-dashed border-[var(--cream-2)] bg-[var(--cream-1)] p-12 text-center">
      <Icon kind={PP_SUBNAV_ICONS[tab]} size={32} stroke={1.6} style={{ color: 'var(--ai-3)' }} />
      <h2 className="mt-4 font-[var(--font-display)] text-xl font-semibold text-[var(--ink-0)]">
        {tab}
      </h2>
      <p className="mt-2 max-w-sm text-[13px] text-[var(--ink-3)]">
        This section is coming soon. Switch to Profile for the full patient chart.
      </p>
    </div>
  );
}
